import React from 'react';
import { 
  FaHtml5, FaCss3Alt, FaJs, FaReact, FaNodeJs, FaPhp, FaPython, FaGitAlt,
  FaJava, FaDocker, FaAws, FaCode
} from 'react-icons/fa';
import { 
  SiTailwindcss, SiMongodb, SiMysql, SiNextdotjs, SiTypescript, SiFramer,
  SiFirebase, SiPostgresql, SiRedux, SiGraphql, SiFigma, SiVite, SiExpress,
  SiPrisma, SiLinux, SiFlutter
} from 'react-icons/si';

export const getSkillIcon = (iconKey, color, className = '') => {
  const props = { className, style: color ? { color } : undefined };

  switch (iconKey) {
    case 'FaHtml5': return <FaHtml5 {...props} />;
    case 'FaCss3Alt': return <FaCss3Alt {...props} />;
    case 'FaJs': return <FaJs {...props} />;
    case 'SiTypescript': return <SiTypescript {...props} />;
    case 'FaReact': return <FaReact {...props} />;
    case 'SiNextdotjs': return <SiNextdotjs {...props} />;
    case 'SiTailwindcss': return <SiTailwindcss {...props} />;
    case 'SiFramer': return <SiFramer {...props} />;
    case 'FaNodeJs': return <FaNodeJs {...props} />;
    case 'SiMongodb': return <SiMongodb {...props} />;
    case 'FaPhp': return <FaPhp {...props} />;
    case 'SiMysql': return <SiMysql {...props} />;
    case 'FaPython': return <FaPython {...props} />;
    case 'FaGitAlt': return <FaGitAlt {...props} />;
    case 'FaJava': return <FaJava {...props} />;
    case 'FaDocker': return <FaDocker {...props} />;
    case 'FaAws': return <FaAws {...props} />;
    case 'SiFirebase': return <SiFirebase {...props} />;
    case 'SiPostgresql': return <SiPostgresql {...props} />;
    case 'SiRedux': return <SiRedux {...props} />;
    case 'SiGraphql': return <SiGraphql {...props} />;
    case 'SiFigma': return <SiFigma {...props} />;
    case 'SiVite': return <SiVite {...props} />;
    case 'SiExpress': return <SiExpress {...props} />;
    case 'SiPrisma': return <SiPrisma {...props} />;
    case 'SiLinux': return <SiLinux {...props} />;
    case 'SiFlutter': return <SiFlutter {...props} />;
    default: return <FaCode {...props} />;
  }
};
